import { Autocomplete, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { sgrColors } from '../../ui/sgr/SgrColors';

interface FilterSelectorProps {
  label: string;
  options: string[];
  selectedOptions: string[];
  setSelectedOptions: (options: string[]) => void;
}

/**
 * Generic component for selecting multiple options from a list
 * @param props Label to show upon the selector, options and selected options
 */
const AutocompleteFilterComponent = (props: FilterSelectorProps) => {
  const { t } = useTranslation();
  const { label, options, selectedOptions, setSelectedOptions } = props;

  return (
    <>
      <Typography
        variant="h6"
        sx={{ fontWeight: 'bold', marginBottom: '-0.5rem' }}
      >
        {t(label)}
      </Typography>
      <Autocomplete
        value={selectedOptions}
        limitTags={2}
        isOptionEqualToValue={(option, value) => option === value}
        multiple
        onChange={(event: any, value: string[]) => {
          setSelectedOptions(value);
        }}
        options={options}
        getOptionLabel={(option) => option}
        filterSelectedOptions={true}
        renderInput={(params) => <TextField {...params} />}
      />
    </>
  );
};

export default AutocompleteFilterComponent;
